import Image from "next/image";
import { HTMLInputTypeAttribute, useState } from "react";

import imageLoader from "../../../../utils/loader";
import classes from "./simpleInput.module.scss";

interface Props<T, K extends keyof T> {
  name?: string;
  label?: string;
  placeholder?: string;
  identifier: K;
  value?: string | number;
  onChange: (identifier: K, value: string) => void;
  isValid?: boolean;
  error?: boolean;
  type: HTMLInputTypeAttribute;
  required?: boolean;
  autoComplete?: boolean;
  readonly?: boolean;
}
const Input = <T, K extends keyof T>({
  onChange,
  identifier,
  label,
  placeholder,
  isValid,
  value,
  type,
  error,
  name,
  autoComplete = true,
  readonly = false,
}: Props<T, K>) => {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <p
        style={{
          width: "fit-content",
        }}
      >
        {label}
      </p>
      <div className={classes.visible}>
        <input
          onChange={(event) => {
            onChange(identifier, event.target.value);
          }}
          name={name}
          placeholder={placeholder}
          type={visible ? "text" : type}
          value={value}
          className={`${classes.input} ${
            !isValid && error ? classes.error : !isValid && classes.error
          }`}
          autoComplete={!autoComplete ? "off" : ""}
          readOnly={readonly}
        />
        {type === "password" && (
          <i
            onClick={() => {
              setVisible(!visible);
            }}
          >
            <Image
              layout="fixed"
              loader={imageLoader}
              src={visible ? "visible.png" : "notVisible.png"}
              width="24px"
              height="24px"
              alt="password visibility"
            />
          </i>
        )}
      </div>
    </div>
  );
};

export default Input;
